import { useEffect, useState } from "react";

import { FeaturedPostsResponse } from "../types";
import { fetchFeaturedPosts } from "../services/featuredPostsService";

export const useFeaturedPosts = () => {
  const [featuredPosts, setFeaturedPosts] =
    useState<FeaturedPostsResponse | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let isMounted = true;

    const loadFeaturedPosts = async () => {
      setLoading(true);
      setError(null);
      try {
        const data = await fetchFeaturedPosts();
        if (isMounted) {
          setFeaturedPosts(data);
        }
      } catch (error) {
        console.error("Failed to load featured posts", error);
        if (isMounted) {
          setError("Failed to load featured initiatives.");
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    loadFeaturedPosts();

    return () => {
      isMounted = false;
    };
  }, []);

  return {
    featuredPosts,
    loading,
    error,
  };
};
